<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('settingsPages.taxLabeling')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="settings-top-bar sticky-header" ref="optionsTopBar">
      <div class="text-right">
        <p class="d-inline-flex">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.saveChanges')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <form>
      <div class="card mar-to-15">
        <div class="card-content">
          <p class="text-danger" v-show="errors.has('error')">
            {{ getError('error') }}
          </p>
          <P>{{$t('vat.generalTaxes')}}</P>
          <table class="table">
            <thead>
                <tr>
                  <th>{{$t('settingTaxes.name')}}</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="tax_rate in taxes">
                <input type="hidden" :name="'tax_rate'+tax_rate.id" v-model="tax_rate.id">
                <td><input type="text"
                            min="0"
                            class="form-control"
                            :name="'name'+tax_rate.id"
                            v-validate="{required: true}"
                            v-model="tax_rate.name">
                    <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                      {{ getError(tax_rate.hash_id) }}
                    </small>
                  </td>
                <td>
                  <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="deleteTax(tax_rate.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.remove')}}
                  </a>
                </td>
              </tr>
              <template>
                <tr>
                  <td></td>
                  <td>
                    <button :title="$t('general.add') + ' ' + $t('settingTaxes.singleTaxLabel')" class="btn add pull-right" @click.prevent="addNewTax()">
                      <img src="/static/img/icons/add.png">
                      {{$t('general.add')}}
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      </div>

      <div class="card mar-to-15">
        <div class="card-content">
          <p class="text-danger" v-show="errors.has('error')">
            {{ getError('error') }}
          </p>
          <P>{{$t('catalogCateg.vat')}} ({{$t('catalogCateg.included')}})</P>
          <table class="table">
            <thead>
                <tr>
                  <th>{{$t('settingTaxes.name')}}</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
              <tr v-for="tax_rate in vat">
                <input type="hidden" :name="'tax_rate'+tax_rate.id" v-model="tax_rate.id">
                <td><input type="text"
                            min="0"
                            class="form-control"
                            :name="'name'+tax_rate.id"
                            v-validate="{required: true}"
                            v-model="tax_rate.name">
                    <small class="text-danger" v-if="errors.has(tax_rate.hash_id)">
                      {{ getError(tax_rate.hash_id) }}
                    </small>
                  </td>
                <td>
                  <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="deleteTax(tax_rate.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.remove')}}
                  </a>
                </td>
              </tr>
              <template>
                <tr>
                  <td></td>
                  <td>
                    <button :title="$t('general.add') + ' ' + $t('settingTaxes.singleTaxLabel')" class="btn add pull-right" @click.prevent="addNewVat()">
                      <img src="/static/img/icons/add.png">
                      {{$t('general.add')}}
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
            <tfoot></tfoot>
          </table>
        </div>
      </div>
    </form>
    <div class="company-details">
      <div class="card pad-bt-15">
        <div class="row display-flex">
          <div class="card-content align-items-center mb-0 col-md-12 mar-lt-15 help-block warning">
            <span class="relative-top"><i class="fa fa-info-circle" aria-hidden="true"></i>{{ $t('settingTaxes.notice') }} <a href="#" @click.prevent="goToCompanyLocations()">{{ $t('settingCompany.generateQrMenuSettings') }}.</a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      // GeneralTopBar,
      [Input.name]: Input
    },
    props: {
      defaultData: {},
      modeldata: {},
      taxesData: {}
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata (value) {
        this.model = value
      },
      taxesData (value) {
        Vue.set(this, 'taxes', value.taxes)
        Vue.set(this, 'vat', value.vat)
      }
    },
    data () {
      return {
        model: this.value || this.modeldata,
        defaults: this.value || this.defaultData,
        taxes: this.value || this.taxesData['taxes'],
        vat: this.value || this.taxesData['vat'],
        loading: true
      }
    },
    computed: {
      ...mapFields(['title', 'description'])
    },
    created () {
      this.$nextTick(function () { this.loading = false })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveTax()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          // if (errors.hasOwnProperty(prop)) {
          this.errors.add(prop, errors[prop])
          // console.warn(this.errors)
          // }
        }
      },
      goToCompanyLocations () {
        console.log('here')
        this.$router.push({
          path: '/settings',
          query: { tabIndex: 1 }
        })
      },
      saveTax () {
        this.$nextTick(function () { this.loading = true })
        var data = {}
        var taxes = this.taxes
        taxes = taxes.concat(this.vat)
        var companyId = this.$session.get('selectedCompany')
        for (var tax in taxes) {
          if (!Number.isInteger(taxes[tax].id) && taxes[tax].id && taxes[tax].id.indexOf('new') === 0) {
            delete taxes[tax].id
          }
          taxes[tax].company_id = companyId
        }
        data.data = JSON.stringify(taxes)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')

        var self = this
        this.apiRequest('/settings/taxes/all', 'PUT', data, function (response) {
          if (response.status === true) {
            self.errors.clear()
            self.$nextTick(function () { self.loading = false })
            swal({'text': 'Taxes saved successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            for (var taxIdx in response.data) {
              response.data[taxIdx].hash_id = response.data[taxIdx].id
            }
            self.$emit('setTaxes')
          } else {
            self.$nextTick(function () { self.loading = false })
            self.handleErrors(response.errors)
          }
        })
      },
      addNewTax () {
        var id = 'new_' + Math.floor(Math.random() * 10000)
        let newRow = {
          'hash_id': id,
          'id': id,
          'name': '',
          'is_vat': false
          // 'type': '',
          // 'amount': ''
        }
        this.taxes.push(newRow)
      },
      addNewVat () {
        var id = 'new_' + Math.floor(Math.random() * 10000)
        let newRow = {
          'hash_id': id,
          'id': id,
          'name': '',
          'is_vat': true
          // 'type': '',
          // 'amount': ''
        }
        this.vat.push(newRow)
      },
      deleteTax (taxId) {
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.taxes)

        // var btnCounter = 3
        var self = this
        swal({
          text: `Are you sure you want to delete this tax?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            if (!Number.isInteger(taxId) && taxId.indexOf('new') === 0) {
              this.taxes.splice(thisTaxIdx, 1)
              swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            } else {
              var id = taxId
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/settings/taxes/' + id, 'DELETE', data, function (response) {
                // console.warn(response)
                if (response.status === true) {
                  var updatedTaxes = self.taxes
                  updatedTaxes.splice(thisTaxIdx, 1)
                  self.$emit('setTaxes')
                  swal({'text': 'Tax deleted successfully', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
                } else {
                  swal({'text': 'Something went wrong, please try again later...', 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
                }
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/Taxes.vue